// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/group/votes.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'votes.group',
	post: false,
	require: function(config, filter) { return sorted('votes.group', filter) > 0 && config.ownerType !== F.OWNER_USER },
	run: function(config, filter, data, query) {
		query.order('COUNT(DISTINCT(r.user_id))', sortReverse('votes.group', filter), sortPriority('votes.group', filter))
	}
}
